import {
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';

export const CustomValidator=(validator: ValidatorFn, controls: string[] = null) => (
  group: FormGroup,
): ValidationErrors | null => {
  if (!controls) {
    controls = Object.keys(group.controls)
  }
  const CustomValidator = group && group.controls && controls
    .some(k => !validator(group.controls[k]));

  return CustomValidator ? null : {
    CustomValidator: true,
  };
};

export class EmptyWhiteSpaceValidator {  
  static EmptyWhiteSpaceValidator(control: FormControl) : ValidationErrors | null {  
    const isWhitespace = control.value ? control.value =='' ? false : (control.value || '').trim().length === 0 : false;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }
}  
